module.exports = __webpack_public_path__ + "145d7c9a8c0de2e5f135aa96f5a49355.png";